import { Box, Button, Flex, SimpleGrid } from '@chakra-ui/react'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'

import { QUERY_LIMIT_MAX, useInfiniteScroll } from '@/components/Session/helpers'
import TutorCardFromQuery from '@/components/TutorCard/TutorCardFromQuery'

const TutorList: React.FC<{ tutors: Query[]; totalItemsCount: number }> = ({
  tutors,
  totalItemsCount,
}) => {
  const [queryLimit, handleLoadMore] = useInfiniteScroll()

  return (
    <>
      <SimpleGrid columns={[1, 2, 3]} width="100%" spacing={['16px', '24px', '32px']}>
        {tutors.map(tutor => (
          <TutorCardFromQuery
            user={tutor}
            displayName={tutor(UserQ.display_name)}
            key={tutor(UserQ.id) ?? 0}
          />
        ))}
      </SimpleGrid>
      {totalItemsCount > queryLimit && queryLimit < QUERY_LIMIT_MAX ? (
        <Flex justifyContent="center" my="24px">
          <Button variant="outline" minWidth="150px" onClick={handleLoadMore}>
            See More
          </Button>
        </Flex>
      ) : (
        <Box mb={12} />
      )}
    </>
  )
}

export default TutorList
